import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MainService } from 'src/app/services/main.service';
@Component({
  selector: 'app-fund-service-unit',
  templateUrl: './fund-service-unit.component.html',
  styleUrls: ['./fund-service-unit.component.scss']
})
export class FundServiceUnitComponent implements OnInit {

  language = JSON.parse(localStorage.getItem('language'));
  language_flag = localStorage.getItem('language_flag');

  @Input()
  disableHeader = false

  private personalID: string;
  private inputOTP: string;
  pidReq = false;
  otpReq = false;
  showLogin = true;
  requestOTP = false;
  showPDPA = false;
  refOTP: string;
  otpMsg: string;
  otpError = this.language.cs_otp;
  loginError = this.language.cs_pid;
  uid: string;
  consentDesc = [];
  consentData = new Map<string, boolean>();

  constructor(private route: ActivatedRoute, private router: Router, private mainService: MainService,
    private loader: NgxUiLoaderService) { }

  ngOnInit() {}

  goDownloadPage() {
    this.router.navigate(['/download-form']);
  }
  goOpenAccountPine(){
    $('#onelivetopineModal').modal('show');
  }

}
